import { Injectable } from '@angular/core';
import { Firestore, addDoc, collection, getDocs, query, where } from '@angular/fire/firestore';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {

	constructor(
		private firestore: Firestore
	) { }

	async getResetEmail(email: string) {
		try {
			const currDate = new Date();
			const thirtyMinutesPastCurr = moment(currDate).add(30, 'minutes').toDate();

			const data = {
				email,
				// didReset: false,
				link: "",
				requestedAt: currDate,
				expiresAt: thirtyMinutesPastCurr
			};
			await addDoc(collection(this.firestore, "resetPassword"), data);
		} catch (err) {
			console.log('Unable to add to Reset Password collection', err);
		}
	}

	async hasRequestedEmail(email: string) {
		try {
			const emailQuery = query(collection(this.firestore, "resetPassword"), where("email", "==", email));
			const emailDocsSnap = await getDocs(emailQuery);

			for (let doc of emailDocsSnap.docs) {
				const docData = doc.data();
				let docRequestedAt = docData['requestedAt'].seconds ? docData['requestedAt'].seconds : docData['requestedAt']._seconds;
				let difference = moment(new Date()).diff(moment(new Date(docRequestedAt * 1000)), 'minutes')
				// console.log(difference);

				if (difference <= 30) {
					return true;
				}
			}

			return false;
		} catch (err) {
			console.log('Unable to check if user has requested email', err);
		}
	}
}
